<template>
  <div v-if="isShow">
    <ActionSheet
      v-if="$device.isMobile"
      :title="title"
      :touch-move-to-close="true"
      :should-show-close="true"
      sheet-height="auto"
      @closeCourseSheet="close"
      @close="close"
    >
      <h4
        v-for="option in options"
        :key="option.key"
        class="action-sheet-option"
        @click="option.click"
      >
        {{ option.title }}
      </h4>
    </ActionSheet>
    <ModalDialog
      v-else
      :value="true"
      hide-footer
      hide-header
      size="xs"
      no-content-gap
      @input="close"
    >
      <div class="modal-main">
        <h4 class="font-weight-bold">{{ $t('好友對戰') }}</h4>
        <b-button
          v-for="option in options"
          :key="option.key"
          size="md"
          variant="primary"
          block
          @click="option.click"
        >
          {{ option.title }}
        </b-button>
      </div>
    </ModalDialog>
  </div>
</template>

<script>
import ModalDialog from '@/components/Modal/ModalDialog.vue';
import ActionSheet from '@/components/Base/ActionSheet.vue';

export default {
  components: {
    ActionSheet,
    ModalDialog,
  },
  computed: {
    isShow() {
      return this.$store.state.env.isSelectPvpActionModalShow;
    },
    title() {
      return this.$t('好友對戰');
    },
    options() {
      return [
        {
          key: 'createPvp',
          title: this.$t('建立對戰'),
          click: () => {
            this.createPvp();
          },
        },
        {
          key: 'joinPvp',
          title: this.$t('加入對戰'),
          click: () => {
            this.joinLobby();
          },
        },
      ];
    },
  },
  methods: {
    joinLobby() {
      this.$store.commit('env/setIsJoinPvpModalShow', true);
    },
    createPvp() {
      if (this.$device.isMobile) {
        this.$router.push({name: 'pvp-menu'});
        this.close();
      } else {
        this.$store.commit('env/setIsCreatePvpModalShow', true);
      }
    },
    close() {
      this.$store.commit('env/setIsSelectPvpActionModalShow', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.action-sheet-option {
  cursor: pointer;
  padding: 12px 16px;
  border: 1px solid #f0f0f0;
}
.modal-main {
  display: flex;
  // padding: var(--spacing-l, 32px);
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-s, 16px);
  align-self: stretch;
}
</style>
